<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import DashboardBox from "@/Components/Common/Helpers/DashboardBox.vue";
import {Link} from "@inertiajs/inertia-vue3";
import SecondaryButton from "@/Components/SecondaryButton.vue";

defineProps({
  company: Object,
});

const fullName = (manager) => {
  let name = manager.firstname;
  if (manager.lastname) {
    name += ` ${manager.lastname}`;
  }

  return name;
}
</script>

<template>
  <AppLayout title="Companies">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Company: <b v-text="company.client"></b>
      </h2>
    </template>

    <div class="mx-auto max-w-7xl py-10 sm:px-6 lg:px-8">
      <div class="md:grid md:grid-cols-3">
        <div class="md:col-span-1">
          <Link :href="route('production.index')">
            <SecondaryButton>Back</SecondaryButton>
          </Link>
        </div>
        <div class="md:col-span-2">
          <table class="text-left text-sm font-light">
            <tbody>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Company ID</th>
              <td class="px-4 py-2 break-words" v-text="company.clientID"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Account Manager</th>
              <td class="px-4 py-2 break-words" v-text="fullName(company.manager)"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Address</th>
              <td class="px-4 py-2 break-words" v-text="company.address"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">City</th>
              <td class="px-4 py-2 break-words" v-text="company.city"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">State</th>
              <td class="px-4 py-2 break-words" v-text="company.state"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Zip</th>
              <td class="px-4 py-2 break-words" v-text="company.zip"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Contact</th>
              <td class="px-4 py-2 break-words" v-text="company.contact"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Phone</th>
              <td class="px-4 py-2 break-words" v-text="company.phone"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Fax</th>
              <td class="px-4 py-2 break-words" v-text="company.fax"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Email</th>
              <td class="px-4 py-2 break-words" v-text="company.email"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">URL</th>
              <td class="px-4 py-2 break-words" v-text="company.www"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Class</th>
              <td class="px-4 py-2 break-words" v-text="company.class"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Notes</th>
              <td class="px-4 py-2 break-words" v-text="company.notes"></td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="grid grid-cols-2 gap-1 md:grid-cols-3 md:gap-2 lg:grid-cols-4 lg:gap-3">
        <DashboardBox :href="`/content/production/clients/work/work.add.php?whoop=${company.ID}`"
                      class="md:col-start-2"
                      label="Enter a New Workorder" icon="folder-plus"></DashboardBox>
        <DashboardBox :href="`/content/production/clients/work/work.view.php?whoop=${company.ID}`"
                      label="View Current Workorders" icon="folder-open"></DashboardBox>
      </div>
    </div>
  </AppLayout>
</template>
